var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRolesActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ico_roles_active",
    "data-name": "Ico roles_active",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_invoice"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8363",
    "data-name": "Group 8363",
    transform: "translate(3.984 2.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8364",
    "data-name": "Group 8364",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    id: "Path_20017",
    "data-name": "Path 20017",
    d: "M15.993,3.231a.364.364,0,0,0-.232-.305L8.145.024a.366.366,0,0,0-.259,0L.271,2.926a.364.364,0,0,0-.232.305c-.011.119-1.009,11.9,7.815,16.315a.363.363,0,0,0,.325,0C17,15.134,16,3.349,15.993,3.231ZM8.016,18.815C.46,14.9.66,5.121.747,3.521L8.016.751,15.286,3.52c.086,1.6.287,11.376-7.269,15.294Z",
    transform: "translate(0 0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    id: "Path_20018",
    "data-name": "Path 20018",
    d: "M19.6,18.957v1h-.725a.363.363,0,0,0-.363.363v3.989a.363.363,0,0,0,.363.363h5.077a.363.363,0,0,0,.363-.363V20.316a.362.362,0,0,0-.363-.363h-.725V18.862a1.815,1.815,0,0,0-1.707-1.81,1.736,1.736,0,0,0-1.309.487A1.96,1.96,0,0,0,19.6,18.957Zm3.989,4.986H19.237V20.679h4.352Zm-2.881-5.877a1.045,1.045,0,0,1,.769-.29A1.091,1.091,0,0,1,22.5,18.862v1.092H20.325v-1A1.231,1.231,0,0,1,20.709,18.065Z",
    transform: "translate(-13.397 -12.338)",
    strokeWidth: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolesActive);
export default __webpack_public_path__ + "static/media/roles_active.11ccb972.svg";
export { ForwardRef as ReactComponent };